import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const SingleChoice = ({ options = [], value, onChange, subQuestionText, extraText, onExtraTextChange, disabled }) => {
  const parsedOptions = typeof options === 'string' ? JSON.parse(options) : options;

  return (
    <div className="flex flex-col gap-3 w-full py-2">
      {parsedOptions.map((opt, idx) => {
        const isSelected = value === opt;
        return (
          <button
            key={idx}
            type="button"
            disabled={disabled}
            onClick={() => onChange(opt)}
            className={`w-full p-4 rounded-xl border-2 text-left font-medium transition-all duration-200 flex items-center justify-between cursor-pointer ${
              isSelected
                ? 'border-blue-600 bg-blue-50/70 text-blue-950 shadow-md'
                : 'border-slate-200 bg-white text-slate-700 hover:border-blue-300 hover:bg-blue-50/30'
            }`}
          >
            <span className="text-sm sm:text-base">{opt}</span>
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${
              isSelected ? 'border-blue-600 bg-blue-600 text-white' : 'border-slate-300'
            }`}>
              {isSelected && <CheckCircle2 className="w-4 h-4" />}
            </div>
          </button>
        );
      })}

      {subQuestionText && value && (
        <div className="mt-3 p-4 bg-slate-50 border border-slate-200 rounded-xl animate-fadeIn">
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            {subQuestionText}
          </label>
          <input
            type="text"
            value={extraText || ''}
            onChange={(e) => onExtraTextChange(e.target.value)}
            disabled={disabled}
            placeholder="Escribe aquí tu respuesta..."
            className="w-full p-3 bg-white border border-slate-300 rounded-lg text-slate-800 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
          />
        </div>
      )}
    </div>
  );
};

export default SingleChoice;
